export var PresetHeader;
(function (PresetHeader) {
    PresetHeader.MAGIC_HEADER_OPEN = 0x4F505245; // OPRE
    PresetHeader.FORMAT_VERSION = 1;
    let ChainKind;
    (function (ChainKind) {
        ChainKind[ChainKind["Midi"] = 0] = "Midi";
        ChainKind[ChainKind["Audio"] = 1] = "Audio";
    })(ChainKind = PresetHeader.ChainKind || (PresetHeader.ChainKind = {}));
})(PresetHeader || (PresetHeader = {}));
